//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import SidebarList from '~/components/partials/sidebar_list'
export default {
  name: 'HeaderMobileList',
  components: {
    SidebarList
  },
  data () {
    return {
      purses: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isGuest: 'auth/isGuest'
    })
  },
  created () {
    if (!this.isGuest) {
      this.purses = this.user.purses.data[0]
    }
  }
}
